export default __webpack_public_path__ + "static/media/sukarn chowdhary_social_media_lead.349aaaed.jpg";